<!--
 * @Date: 2023-07-24 15:02:36
 * @LastEditors: chuhongguang
 * @desc: 移动端适配导航栏
-->
<template>
  <div class="m-nav">
    <div class="m-nav-top"  @click.stop>
      <van-image width="74.28px" height="39px" fit="cover" :src="require('../../../assets/logo.png')" @click="gotoHome" />
        <div class="nav-top-r">
          <template v-if="!!Authorization">
          <van-icon name="bell" size="18"  color="#8a919f" @click="goToNotification" />
          <div class="circle" @click="gotoUserInfo">{{userNameFirst}}</div>
        </template>
        <div></div>
      </div>
    </div>
    <van-tabs ref="tabs" v-model="active"  >
      <van-tab v-for="item in navList" :name="item.name" :key="item.name" :title="item.title" :to="item.path"></van-tab>
    </van-tabs>
  </div>
</template>

<script>
// 第三方
import { Tab, Tabs, Icon, Image as VanImage } from 'vant'
import { mapState } from 'vuex'
// 配置
import { navList } from './controller/options.js'
import { matchMedia } from '@/utils/DomTool.js'

export default {
  name: 'LyNavMobile',

  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Icon.name]: Icon,
    [VanImage.name]: VanImage
  },

  props: {
    activeIndex: { type: String, default: '' }
  },

  data () {
    return {
      navList,
      active: this.$route.name
    }
  },

  computed: {
    ...mapState(['Authorization', 'userName']),
    userNameFirst () {
      let firstChar = this.userName ? this.userName.charAt(0) : '观'

      // 如果是英文字符，转为大写
      if (/[a-zA-Z]/.test(firstChar)) {
        firstChar = firstChar.toUpperCase()
      }

      return firstChar
    },

    // 当前是否为移动端
    isMobile () {
      return matchMedia() === 'isMobile'
      // return ''
    }
  },

  watch: {
    $route (val) {
      this.active = val.name
    },

    isMobile (val) {
      if (val) {
        // this.$refs.tabs && this.$refs.tabs.resize()
        // console.log('🚀 ~ file: index.vue:75 ~ this.$nextTick ~ this.$refs.tabs:', this.$refs.tabs)
        console.log(this.active)
      }
    }
  },

  mounted () {
    this.$nextTick(() => {
      // this.$refs.tabs.resize()

      // this.$refs.tabs.scrollTo(this.active)
    })
  },

  methods: {
    // 前往首页
    gotoHome () {
      this.$router.push({ path: '/home' })
    },

    // 前往用户管理页面
    gotoUserInfo () {
      this.$router.push({ path: '/userInfo' })
    },

    // 前往消息中心页面
    goToNotification () {
      this.$router.push({ path: '/notification' })
    }
  }
}
</script>

<style scoped>
/* 写一段css, 画一个 宽高36px的圆形，背景色是浅绿色，边框是深绿色, 圆形中心有一个 '褚' 字，居中垂直对齐。*/
.m-nav {
  padding-top: 10px;
  background: #ffffff;
  -moz-box-shadow: 2px 2px 5px #b0b0b0;
  -webkit-box-shadow: 2px 2px 5px #b0b0b0;
  box-shadow: 2px 2px 5px #b0b0b0;

}
.m-nav-top {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #bdb5b5;
  padding-bottom: 10px;
}
.nav-top-r{
  padding-right: 10px;
  display: flex;
  align-items: center;
}

.circle {
  width: 36px;
  height: 36px;
  background-color: #b7242a;  /* 浅绿色背景 */
  border: 2px solid #a32125;  /* 深绿色边框 */
  border-radius: 50%;  /* 圆形 */
  display: flex;  /* 使用 flex 布局将文本居中 */
  justify-content: center;
  align-items: center;
  font-family: Arial, sans-serif;  /* 选择适合显示中文的字体 */
  font-size: 18px;
  color: #e3c672;  /* 字体颜色 */
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Mobile/Nav/index.vue